/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SkillsControllerCreateMutationResponse, SkillsControllerCreate400, SkillsControllerCreate401, SkillsControllerCreate403 } from "../../models/skillsController/SkillsControllerCreate";

function getSkillsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/skills` as const }  
  return res
}

/**
 * @summary Create a skill in a user, org, or global target
 * {@link /api/v1/skills}
 */
export async function skillsControllerCreate(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<SkillsControllerCreateMutationResponse, ResponseErrorConfig<SkillsControllerCreate400 | SkillsControllerCreate401 | SkillsControllerCreate403>, unknown>({ method : "POST", url : getSkillsControllerCreateUrl().url.toString(), ... requestConfig })  
  return res.data
}